import React, {useEffect} from 'react';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {getModelNameByDataCollectionName, previewDataModelDocumentationAPI} from "../../../api/DataModel/data-model";
import LoadingScreen from "../../../containers/LoadingScreen/LoadingScreen";


const DataCollectionModelDocumentationPreview = () => {
    const {dataCollection} = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {

            getModelNameByDataCollectionName(dataCollection)
                .then(dataModel => {
                    previewDataModelDocumentationAPI(dataModel)
                        .then(doc => {
                            if (doc !== undefined) {
                                const blob = new Blob([doc], {type: "application/pdf"});
                                const url = window.URL.createObjectURL(blob);
                                navigate(url);
                            }
                        })

                })

        },
        [dataCollection, location.state]
    )
    ;
    return (
        <LoadingScreen/>
    );
};

export default DataCollectionModelDocumentationPreview;
